import React from "react";
import AdminDocumentUploader from "./AdminDocumentUploader";
import AdminDocumentViewer from "./AdminDocumentViewer";

const AdminDocumentModal = ({ isOpen, onClose, booking, type, onUploadSuccess }) => {
  if (!isOpen || !booking) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="p-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-bold">Manage Documents - {booking.bookingReference || "Booking"}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 font-bold text-xl">&times;</button>
        </div>
        <div className="p-4 overflow-y-auto">
          <AdminDocumentViewer adminDocuments={booking.adminDocuments} />
          <AdminDocumentUploader
            type={type}
            bookingId={booking._id}
            onUploadSuccess={onUploadSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminDocumentModal;
